import React from 'react';

import SvgIcon from "../../../SharedComponents/Icons";

import './index.sass'


const CheckboxFilter = ({ className, options, paramName, selected, setData, updateUrl }) => {

  const handleClick = (option) => {
    const newData = selected.includes(option.id)
      ? selected.filter(elem => elem !== option.id)
      : [...selected, option.id];

    setData(newData);
    updateUrl({ [paramName]: newData, page: '' })
  };


  return (
    <div className={`checkbox-filter ${className || ''}`}>
      { options.map(option =>
        <div key={option.id}
             onClick={() => handleClick(option)}
             className="checkbox-filter__option">

          <div className={`checkbox-filter__checkbox ${selected.includes(option.id) ? 'checked' : ''}` }>
            <SvgIcon name="check" size={18} />
          </div>

          <div className='checkbox-filter__label'>
            { option.name }
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckboxFilter;
